import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import cardDepositInfo from '@perpay-web/fintech/assets/images/cardDepositInfo.png';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './CardDepositInfoModal.scss';

const CardDepositInfoModal = ({ onClose, className }) => (
    <BottomSheet
        className={getClassName(styles['modal-container'], className)}
        onClose={onClose}
    >
        <div className={styles['modal-content']}>
            <img
                className={styles['card-img']}
                src={cardDepositInfo}
                alt='Perpay Credit Card'
            />
            <div>
                <p>
                    A regular deposit from your paycheck is required for your
                    Perpay Credit Card to remain active. The deposit is
                    perfectly synced with your pay cycle to help you pay your
                    balance on time and boost your credit.
                </p>
                <p>
                    Any additional funds from your paycheck will be safely
                    stored in your Perpay account, ready for withdrawal to a
                    bank of your choice.
                </p>
                <p>
                    Your card ships after we receive your first direct deposit.
                    Activate when it arrives to access your entire credit limit.
                </p>
            </div>
        </div>
    </BottomSheet>
);

export default CardDepositInfoModal;
